export {
  discardVersionAnnouncement,
  getNewVersionAnnouncement,
} from './version-info';



// WEBPACK FOOTER //
// ./client/features/version-info/index.js